import { defineMessages } from 'react-intl';

export const i18n: {
	commentIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	commentIconLabel: {
		id: 'search-page.comment-icon-label',
		defaultMessage: 'Comment',
		description: 'Label for the comment icon. ',
	},
});
